module.exports = __webpack_public_path__ + "static/media/DSC_DH.0dd2b5e0.png";